import { lazy } from 'react';

/**
 * A wrapper around React.lazy that allows for lazy loading of named exports.
 * Should be used only for route-level components.
 * @see https://github.com/facebook/react/issues/14603#issuecomment-726551598
 */
export function lazyComponent<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Type `any` is used here because of poor React typings
  T extends React.ComponentType<any>,
  I extends { [K2 in K]: T },
  K extends keyof I,
>(factory: () => Promise<I>, name: K): I {
  return Object.create({
    [name]: lazy(() => factory().then((module) => ({ default: module[name] }))),
  });
}
